import { z } from 'zod';

const ApiOriginSchema = z
  .string()
  .trim()
  .min(1, '請輸入 API URL')
  .superRefine((value, ctx) => {
    let parsed: URL;
    try {
      parsed = new URL(value);
    } catch {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '請輸入有效的 HTTPS origin',
      });
      return;
    }
    if (
      parsed.protocol !== 'https:' ||
      parsed.username ||
      parsed.password ||
      parsed.pathname !== '/' ||
      parsed.search ||
      parsed.hash ||
      parsed.port
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '僅允許 HTTPS origin，不能包含帳密、非預設 port、路徑或參數',
      });
    }
  })
  .transform(value => new URL(value).origin);

export const ApiDomainUpsertSchema = z.object({
  origin: ApiOriginSchema,
  isActive: z.boolean(),
  priority: z
    .number()
    .int('優先級必須是整數')
    .min(0, '優先級不可小於 0')
    .max(10000),
  note: z.string().trim().max(500, '備註不可超過 500 字').optional(),
});

export type ApiDomainUpsertValues = z.infer<typeof ApiDomainUpsertSchema>;
